export default __webpack_public_path__ + "static/media/black_man_analytics.a9ba22cb.png";